import Doces from "../Components/Receitas/Doces/Doces.jsx";

export default function ReceitasDoces() {
  return <Doces />;
}
